import bankCodes from '@/languages/ko-kr/bank-codes'

export default {
  'banks': '@:terms.bank-account 정보',
  'bank': '@:terms.bank',
  'bank-account': '@:terms.bank-account',
  'number': '계좌번호',
  'withdrawal' : '@:terms.withdrawal @:terms.bank',
  'owner': '예금주',
  'search': '찾기',
  'currency': '@:terms.currency',
  'payment-register': '@:terms.payment하기',
  'delete': '@:terms.delete하기',
  'message': {
    'empty': '@:terms.bank-account 등록하기',
    'empty-cert': '@:terms.certificate로 @:terms.account 추가하기'
  },
  'error': {
    'banks': '@:terms.bank-account 목록을 불러오는데 실패하였습니다.',
    'delete': '@:terms.bank-account를 삭제하는데 실패하였습니다.',
    'owner': '@:pages.banks.owner를 조회하는데 실패하였습니다.',
    'create': '@:terms.bank-account를 추가하는데 실패하였습니다.',
    'remove': '@:terms.bank-account를 삭제하는데 실패하였습니다.',
    'tax': '@:terms.payment 정보를 불러오는데 실패하였습니다.',
  },
  'bank-codes': {
    ...bankCodes,
  },
  'confirm': {
    'message': {
      'delete': '@:terms.bank-account를 삭제할까요?',
    },
  },
  'verification': {
    'required': {
      'number': '@:pages.banks.number를 입력해주세요.',
      'owner': '@:pages.banks.owner를 입력해주세요.',
      'bank-code': '@:terms.bank를 선택해주세요.',
    },
    'failed': {
      'owner': '@:pages.banks.owner를 찾지 못하였습니다. @:terms.bank @:pages.banks.number를 확인해주세요.',
    },
  },
  'notice': '* 케이뱅크@:terms.bank, 한국카카오@:terms.bank, 시티@:terms.bank, 제주@:terms.bank은 지원하지 않습니다.',
  'transfer': '@:terms.transfer하기',
  'notice-transfer': '@:pages.banks.transfer 기능은 ' +
    '@:terms.certificate로 등록된 @:terms.account만 사용이 가능합니다.'
}
